module.exports = __webpack_public_path__ + "static/img/elm.d5b0c4bb.png";